import React from 'react';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface ToastManagerProps {
  className?: string;
}

// Custom styling to ensure the toast container doesn't affect layout
const toastContainerStyle = `
  .Toastify {
    position: fixed;
    z-index: 9999;
    top: 1rem;
    right: 1rem;
    height: 0;
    margin: 0;
    padding: 0;
  }
  
  .Toastify__toast-container {
    margin: 0;
    padding: 0;
    position: absolute;
  }
`;

const ToastManager: React.FC<ToastManagerProps> = ({ className = "" }) => {
  return (
    <>
      <style>{toastContainerStyle}</style>
      <ToastContainer 
        position="top-right"
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        className={`p-0 ${className}`}
      />
    </>
  );
};

// Export utility functions for displaying different types of toasts
export const showStatusUpdateToast = (targetStatus: string, orderCount: number) => {
  const orderText = orderCount === 1 ? "order" : "orders";
  let toastType: "success" | "info" | "warning" = "success";
  let statusMessage = "";
  
  // Set toast type and message based on the status
  if (targetStatus === 'En_cour_de_preparation') {
    toastType = "warning";
    statusMessage = `${orderCount} ${orderText} are now being prepared`;
  } else if (targetStatus === 'prepared') {
    toastType = "success";
    statusMessage = `${orderCount} ${orderText} have been prepared successfully`;
  } else if (targetStatus === 'En_cour_d_enlevement') {
    toastType = "info";
    statusMessage = `${orderCount} ${orderText} are now in transit`;
  } else {
    statusMessage = `Successfully updated ${orderCount} ${orderText}`;
  }
  
  // Show the toast notification
  toast[toastType](statusMessage, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

// Utility function for displaying error toasts
export const showErrorToast = (errorMessage: string) => {
  toast.error(errorMessage, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

export default ToastManager;
